const orthodontics = {
  hero: {
    titlePrefix: "Съвременна",
    titleAccent: "Ортодонтия",
    titleSuffix: "за Перфектна Усмивка",
    description:
      "Постигнете перфектно подреждане и красива усмивка с нашите модерни ортодонтски лечения. Нашият експертен екип използва най-новите технологии, за да предостави комфортни и ефективни решения за всички възрасти.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Разгледайте Процеса",
    },
    patientAlt: "Доволен Пациент",
    patientCount: "1000+ Доволни Пациенти",
    rating: "Оценка 4.9 от 5",
    imageAlt: "Съвременно Ортодонтско Лечение",
    tech: {
      calloutTitle: "Съвременни Техники",
      calloutSubtitle: "Безопасно и Комфортно",
    },
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ НАС",
    intro:
      "Постигнете цялостно ортодонтско лечение с фокус върху комфорта, естетиката и дългосрочните резултати.",
    items: [
      {
        title: "Перфектно Подреждане",
        description:
          "Постигнете перфектно подредени зъби за красива усмивка и подобрена функционалност на захапката.",
      },
      {
        title: "По-добро Орално Здраве",
        description:
          "По-изправените зъби се почистват по-лесно, намалявайки риска от кариес и заболявания на венците.",
      },
      {
        title: "Съвременни Технологии",
        description:
          "Възползвайте се от по-кратко време за лечение с нашите модерни ортодонтски технологии.",
      },
      {
        title: "Персонализирано Лечение",
        description:
          "Индивидуални планове за лечение, съобразени с вашите специфични дентални нужди и цели.",
      },
    ],
  },
  process: {
    heading: "НАШАТА ОРТОДОНТСКА ПРАКТИКА",
    intro:
      "Оптимизиран, комфортен път към вашата перфектна усмивка с нашия експертен ортодонтски екип",
    imageAlt: "Процес на Ортодонтско Лечение",
    calloutTitle: "Експертна Грижа",
    calloutSubtitle: "Опитни Специалисти",
    items: [
      {
        title: "Първоначална Консултация",
        description:
          "Обстоен преглед на вашата зъбна структура, за да оценим нуждите ви и да обсъдим възможностите за лечение.",
      },
      {
        title: "Индивидуален План за Лечение",
        description:
          "Създаване на персонализиран ортодонтски план, съобразен с вашите специфични нужди за подреждане на зъбите.",
      },
      {
        title: "Активно Лечение",
        description:
          "Редовни посещения за корекции, за да гарантираме, че лечението ви напредва според плана.",
      },
      {
        title: "Фаза на Задържане",
        description:
          "Поддържане на вашата нова усмивка с персонализирани ретайнери след приключване на активното лечение.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Намерете отговори на често задавани въпроси за нашите ортодонтски лечения",
    items: [
      {
        question: "Колко време обикновено отнема ортодонтското лечение?",
        answer:
          "Продължителността на лечението варира според индивидуалните нужди, но обикновено е между 12 и 36 месеца. Факторите, които влияят върху времето за лечение, включват тежестта на проблемите с подреждането, възрастта на пациента и спазването на препоръките за лечение.",
      },
      {
        question: "Какви видове брекети и ортодонтски опции предлагате?",
        answer:
          "Предлагаме пълна гама от опции, включително традиционни метални брекети, керамични (прозрачни) брекети, самолигиращи брекети и прозрачни алайнери като Invisalign. По време на консултацията ще препоръчаме най-добрата опция за вашия конкретен случай.",
      },
      {
        question: "Болезнени ли са ортодонтските лечения?",
        answer:
          "Може да изпитате лек дискомфорт или натиск след корекции, но съвременните ортодонтски техники са проектирани да минимизират болката. Всеки дискомфорт обикновено отшумява в рамките на няколко дни и може да се овладее с обикновени болкоуспокояващи.",
      },
      {
        question: "Колко често ще трябва да посещавам за корекции?",
        answer:
          "Повечето пациенти се нуждаят от корекции на всеки 4-8 седмици, в зависимост от вида на лечението и индивидуалния прогрес. Ще създадем график, съобразен с вашия специфичен план за лечение.",
      },
      {
        question: "Какво се случва след свалянето на брекетите?",
        answer:
          "След активното лечение навлизате във фазата на задържане. Ще ви бъдат поставени ретайнери за поддържане на новата ви усмивка. Първоначално ще ги носите постоянно, след което постепенно ще преминете само към нощно носене. Редовните прегледи ще следят вашите резултати.",
      },
    ],
    bottomLine: "Имате още въпроси? Ние сме тук, за да помогнем!",
    cta: "Свържете се с Нас",
  },
};

export default orthodontics;

